import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import en from "./locales/en/transalation.json"
import ru from "./locales/ru/transalation.json"
import uz from "./locales/uz/transalation.json"
import LanguageDetector from "i18next-browser-languagedetector"

// Clear old cached language if it was hardcoded
if (typeof window !== 'undefined' && !window.localStorage.getItem('i18nextLng')) {
  window.localStorage.removeItem('i18nextLng');
}

i18next
.use(initReactI18next)
.use(LanguageDetector)
.init({
  resources:{
    ru:{
      translation:ru,
    },
    en:{
        translation: en,
    },
    uz:{
      translation: uz
    }
  },
  lng: 'ru', // Set Russian as default language
  fallbackLng: 'ru',
  detection:{
    order:['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
    caches:['cookie' , 'localStorage']
  }
})
export default i18next